import { trackExperimentViewed } from '@mc/track-event'

import { COLLAPSED_PAINTED_DOOR_FLAG_NAME } from '../constants'

export const trackCollapsedPaintedDoorViewed = () => {
  trackExperimentViewed(COLLAPSED_PAINTED_DOOR_FLAG_NAME)
}
